module.exports = __webpack_public_path__ + "static/FL1-cc9f58bbc87e54f0ce923bffa8e34eb9.png";